<template>
  <v-hover v-slot="{ hover }">
    <v-row
      align="center"
      :class="[
        saldato ? 'grey--text lighten-4' : '',
        hover ? 'grey lighten-4' : '',
        contabile.fake ? 'red lighten-5 py-2' : ''
      ]"
      class="px-2"
      no-gutters
    >
      <v-snackbar
        v-model="alertError"
        top
        color="error"
        icon="mdi-alert"
        border="left"
        elevation="2"
        class="mb-2"
        timeout="6000"
      >
        Errore durante la modifica della contabile.
      </v-snackbar>
      <v-col cols="2" :class="contabile.fake ? 'red--text' : ''">
        {{ contabile.fake ? "Record Mancante" : cliente ? cliente.nome : "—" }}
      </v-col>
      <v-col cols="2"> {{ dataFormatted }}</v-col>
      <v-col cols="1">
        <span
          v-if="!contabile.fake"
          class="pa-1"
          :class="
            contabile.tipo == 1
              ? contabile.verde
                ? 'green--text'
                : 'blue--text'
              : contabile.tipo == 2 ? 'text-no-wrap green white--text' : 'purple--text'
          "
        >
          € {{ contabile.importo.toFixed(2) }}
        </span>
      </v-col>
      <v-col cols="1"> {{ contabile.ddt }} </v-col>
      <v-col cols="1">
        <v-btn v-if="contabile.id_conteggio" icon color="purple" @click="$refs.dettaglio_conteggio.open()"><v-icon>mdi-clipboard-list</v-icon></v-btn>
        <DettaglioConteggio :id_conteggio="contabile.id_conteggio" :ordine="ordine" ref="dettaglio_conteggio"/>
      </v-col>
      <v-col cols="1">
        <ContabileOrdineRef
          :id_ordine="contabile.id_ordine"
          :id_subconteggio="contabile.id_subconteggio"
          :readonly="contabile.fake"
          ref="contabileOrdineRef"
        />
      </v-col>
      <v-col cols="1" class="mb-2">
        <v-checkbox
          v-if="!contabile.fake"
          v-model="saldato"
          :readonly="true"
          :label="formatData(contabile.ts_saldo)"
          dense
          hide-details
          @click="toggle_saldato(true)"
        ></v-checkbox>
      </v-col>
      <v-col cols="2">
        {{ contabile.note }}
      </v-col>
      <v-col cols="1">
        <v-dialog v-if="!contabile.fake" v-model="dialogElimina" width="400">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title> Elimina contabile </v-card-title>
            <v-card-text>
              Sei sicuro di voler eliminare il contabile?
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="grey" text @click="dialogElimina = false"
                >Annulla</v-btn
              >
              <v-btn
                color="red"
                outlined
                :loading="loadingElimina"
                @click="eliminaContabile"
                >Elimina</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <modifica_contabile
          v-if="!contabile.fake"
          :contabile="contabile"
          @update-contabile="updateContabile"
        />
      </v-col>
    </v-row>
  </v-hover>
</template>

<script>
import modifica_contabile from "./modifica_contabile.vue";
import contabile_element_mixin from "../mixin/contabile_element_mixin";
import ContabileOrdineRef from "./contabile_ordine_ref.vue";
import DettaglioConteggio from "../../Conteggi/desktop/dettaglio_conteggio/conteggio_dettaglio.vue";
export default {
  components: {
    modifica_contabile,
    DettaglioConteggio,
    ContabileOrdineRef,
  },
  mixins: [contabile_element_mixin],
};
</script>